'use client';

import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { JobStatus } from '@repo/api-gw-sdk';
import type { ReactNode } from 'react';
import { JobStatuses } from '@/data/inventory/data';
type CheckStatus = 'ok' | 'error' | 'pending';
interface CheckResultRowProps {
  status: CheckStatus;
  label: string;
  children?: ReactNode;
}
const checkStatusToJobStatus: Record<CheckStatus, JobStatus> = {
  ok: JobStatus.JOB_COMPLETED,
  error: JobStatus.JOB_FAILED,
  pending: JobStatus.JOB_PENDING
};
export const CheckResultRow = t0 => {
  const $ = _c(15);
  const {
    status,
    label,
    children
  } = t0;
  const jobStatus = JobStatuses[checkStatusToJobStatus[status]];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "8px",
      alignItems: "flex-start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${jobStatus?.icon} text-2xl`;
  const t3 = jobStatus?.iconColor;
  let t4;
  if ($[1] !== t3) {
    t4 = {
      color: t3
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t4) {
    t5 = <i className={t2} style={t4} />;
    $[3] = t2;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      gap: "4px",
      flex: 1
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== label) {
    t7 = <Typography variant="subtitle2">{label}</Typography>;
    $[7] = label;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== children || $[10] !== t7) {
    t8 = <Stack sx={t6}>{t7}{children}</Stack>;
    $[9] = children;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t8) {
    t9 = <Stack direction="row" sx={t1}>{t5}{t8}</Stack>;
    $[12] = t5;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};